import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import { SupplierSettingsForm } from '../models/company-form.model';
import {
  selectIsLoadingSupplierSettings,
  selectIsSavingSupplierSettings,
  selectSupplierSettings,
} from './company.selectors';

@Injectable({ providedIn: 'root' })
export class CompanySupplierSettingsSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly supplierSettings: Signal<Nullable<SupplierSettingsForm>> =
    this._store.selectSignal(selectSupplierSettings);
  public readonly isLoadingSupplierSettings: Signal<boolean> =
    this._store.selectSignal(selectIsLoadingSupplierSettings);
  public readonly isSavingSupplierSettings: Signal<boolean> =
    this._store.selectSignal(selectIsSavingSupplierSettings);
}
